<template>
  <section class="panel">
    <Popup
      v-if="filePopup.opened"
      title="Добавить абонентов через файл"
      @close="onFilePopupClose"
      @approve="onFilePopupApprove"
    >
      <p>
        Загрузите файл с SIP-аккаунтами в формате csv. <br />
        После загрузки файла каждой квартире адреса будет назначен
        соответствующий файлу SIP-аккаунт для вызова.
      </p>
      <FormFile v-model="filePopup.file" label="Загрузить файл с абонентами" />
    </Popup>

    <Popup
      v-if="clientPopup.opened"
      :title="clientPopup.title"
      :subTitle="clientPopup.subTitle"
      @close="onClientPopupClose"
      @approve="onClientPopupApprove"
    >
      <FormList v-model="clientPopup.value" :list="clientPopup.list" />
    </Popup>
    <AddPanel v-if="isOpenAddPanel" @close="onAddPanelClose" />
    <PanelDeleteConfirm
      v-if="panelDeleteConfirm.active"
      :loading="panelDeleteConfirm.loading"
      :disabled="panelDeleteConfirm.loading"
      :panel-count="rowsSelected.length"
      @approve="onDeletePanelsApprove"
      @close="panelDeleteConfirm.active = false"
    />
    <IntercomDisconnectConfirm
      v-if="gateDisconnectConfirm.active"
      :address-name="currentAddress"
      :loading="gateDisconnectConfirm.loading"
      @approve="onGateDisconnectApprove"
      @close="gateDisconnectConfirm.active = false"
    />
    <div class="panel__filters">
      <Filters v-model="filtersActive" :filters="filters" />
    </div>
    <div class="panel__list">
      <Table
        v-model="rowsSelected"
        :columns="tableColumns"
        :rows="tableRows"
        @switcherClick="onSwitcherClick"
        @rowClick="onRowClick"
      />
      <div class="panel__add">
        <button class="btn panel__add-button" @click="onAddPanelClick">
          <icon-base icon-name="plus-outlined" class="" />
          Добавить панель
        </button>
      </div>
      <Pagination
        v-model="panelsMeta.current_page"
        v-bind="{
          totalItems: panelsMeta.total,
          itemsByPage: panelsMeta.per_page,
        }"
        @switchPage="onSwitchPage"
      />
    </div>
    <div class="panel__actions">
      <Actions
        :actions="rowsSelected.length ? actions.selected : actions.default"
      />
    </div>
  </section>
</template>

<script>
import Popup from '../../components/Popup.vue'
import Filters from '../../components/Filters.vue'
import Table from '../../components/Table.vue'
import Actions from '../../components/Actions.vue'
import MockIntercomPanel from '../../mixins/Mock/MockIntercomPanel.js'
import FormFile from '../../components/Form/File.vue'
import FormList from '../../components/Form/List.vue'
import Pagination from '../../components/Pagination.vue'
import IntercomDisconnectConfirm from '../Popup/IntercomDisconnectConfirm.vue'
import PanelDeleteConfirm from '../Popup/PanelDeleteConfirm.vue'
import IconBase from '../../components/Icons/IconBase.vue'
import AddPanel from '../../components/panels/AddPanel.vue'

export default {
  name: 'AddressList',
  mixins: [MockIntercomPanel],
  components: {
    Popup,
    Filters,
    Table,
    Actions,
    FormFile,
    FormList,
    Pagination,
    IntercomDisconnectConfirm,
    PanelDeleteConfirm,
    IconBase,
    AddPanel,
  },
  data() {
    return {
      filtersActive: {},
    }
  },
  computed: {
    cuid() {
      return this.$route.params.intercomId
    },
    isOpenAddPanel() {
      return this.$store.getters['isOpenAddPanel']
    },
    panelsMeta() {
      return this.$store.getters['panelsMeta']
    },
  },
  watch: {
    filtersActive: {
      handler(value) {
        if (value.status === null) {
          value.status = ''
        }

        this.filterPanels(value)
      },
      deep: true,
    },
  },
  methods: {
    onAddPanelClick() {
      this.$store.dispatch('setToggleAddPanel', true)
    },
    onAddPanelClose() {
      this.$store.dispatch('setToggleAddPanel', false)
    },
    async onDeletePanelsApprove() {
      await this.onDeletePanels(
        this.cuid,
        this.rowsSelected,
        this.currentOrganizationId
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.panel {
  width: 100%;

  &__filters,
  &__list {
    margin: 0 $space-md $space-lg;
  }

  &__add {
    margin-top: $space-lg;
  }

  &__add-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-weight: 600;
    font-size: 16px;
  }
}
</style>
